<template>
  <div>
      Error 404
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>